import { z } from 'zod';

export const phoneSchema = z.object({
  phone: z
    .string()
    .min(11, {
      message: 'Phone number must have 11 digits for BD number',
    })
    .max(11, {
      message: 'Phone number must have 11 digits for BD number',
    })
    .refine(
      value => /^(?:01[3-9]\d{8})$/.test(value),
      'Phone number must be a valid BD number',
    ),
  dialCode: z.string(),
  countryCode: z.string(),
});

export type PhoneSchema = z.infer<typeof phoneSchema>;
